import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { useT } from '../app/preferences.ts';

export type TurnKind = 'mine' | 'wait' | 'check' | 'over';

const EMOJI: Record<TurnKind, string> = { mine: '👉', wait: '🤔', check: '😮', over: '🏁' };

/** The big "whose turn is it?" message at the top of the game panel. */
export function TurnBanner({ kind, text }: { kind: TurnKind; text: string }) {
  return (
    <div className={`turn-banner ${kind}`} role="status" aria-live="polite">
      <span className="emoji" aria-hidden="true">
        {EMOJI[kind]}
      </span>
      <span>{text}</span>
    </div>
  );
}

/** Wide screens have room for the moves next to the board, so the list starts open there. */
const WIDE = '(min-width: 761px) and (min-aspect-ratio: 6/5)';

/** Folded-away move list on phones (out of the way for kids); open beside the board on larger screens. */
export function MovesFold({ children }: { children: ReactNode }) {
  const t = useT();
  const [open, setOpen] = useState(() => window.matchMedia(WIDE).matches);
  return (
    <details className="moves-details" open={open} onToggle={(e) => setOpen(e.currentTarget.open)}>
      <summary>
        <span className="emoji" aria-hidden="true">
          📜
        </span>
        {t('game.moves')}
        <ChevronDown className="chevron" size={22} />
      </summary>
      {children}
    </details>
  );
}
